import { useEffect, useState } from "react";
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import FullScreenLoading from "../../Components/Loading/FullScreenLoading";
import { clearAuthStorage } from "../../helper";
import { logout } from "../../Requests/authRequests";
import { getCurrentUserInfo } from "../../Requests/customerReportRequests";
import UserInfoBox from "./UserInfoBox";

const CustomerNavbar = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [displayName, setDisplayName] = useState("");

  useEffect(() => {
    getCurrentUserInfo()
      .then((resp) =>
        setDisplayName(resp.shownName ?? resp.sahraUser?.name ?? ""),
      )
      .catch(() => toast.error("عدم ارتباط با سرور"))
      .finally(() => setLoading(false));
  }, []);

  const logoutHandler = () => {
    setLoading(true);
    const token = localStorage.getItem("token");
    if (!token) {
      clearAuthStorage();
      navigate("/");
      return;
    }
    logout(token)
      .then(() => {
        clearAuthStorage();
        navigate("/");
      })
      .catch(() => toast.error("عدم ارتباط با سرور"))
      .finally(() => setLoading(false));
  };

  if (loading) return <FullScreenLoading />;

  return (
    <div className="flex flex-col justify-start items-start mb-5 relative">
      <div className="bg-sky-600 w-full flex flex-row justify-start items-center gap-5 p-2 z-[101]">
        <span className="text-white text-sm">{displayName}</span>
        <LogoutRoundedIcon
          className="text-white mr-auto cursor-pointer hover:text-blue-200"
          onClick={logoutHandler}
        />
      </div>
      <div className="max-w-min absolute left-0 top-10">
        <UserInfoBox isCustomer customerDisplayName={displayName} />
      </div>
    </div>
  );
};

export default CustomerNavbar;
